import { ref } from "vue";

const wcPage = ref({});
const wcPageApi = ref({});
export default {
    page: wcPage,
    api: wcPageApi
};